<template xmlns:b-row="http://www.w3.org/1999/html">
  <b-card>
    <div
      v-if="isLoading"
      class="text-center"
    >
      <b-spinner />
      <p>Carregando...</p>
    </div>

    <b-form v-if="!isLoading">
      <b-card-header class="low-padding">
        <b-card-title>
          Configurações
        </b-card-title>
        <b-card-title>
          <b-button
            size="sm"
            variant="flat-secondary"
            @click="reset"
          >
            <feather-icon
              icon="RotateCwIcon"
              size="15"
            />
          </b-button>
        </b-card-title>
      </b-card-header>

      <validation-observer ref="rulesRegistration">
        <div
          v-if="!salesManager && ['sales', 'root', 'management_processes'].includes(userData.permission_type)"
          class="mb-2"
        >
          <b-button
            v-b-modal.modal-log
            size="sm"
          >
            Ver log de EV
          </b-button>
        </div>

        <div
          class="mb-2"
        >
          <b-button
            v-b-modal.modal-log-cerc
            size="sm"
          >
            Ver log de CERC
          </b-button>
        </div>

        <h3>Agendamento de Tour</h3>

        <div
          class="mb-2"
        >
          <b-form-group
            label="Link para agendar CERC"
            label-for="link_to_schedule_cerc"
          >
            <b-input-group>
              <b-form-input
                id="link_to_schedule_cerc"
                :value="results.link_to_schedule_cerc"
                readonly
              />

              <b-input-group-append>
                <b-button
                  variant="outline-primary"
                  title="Copiar link"
                  @click="sendToClipboard(results.link_to_schedule_cerc)"
                >
                  <feather-icon icon="CopyIcon" />
                </b-button>
                <b-button
                  variant="outline-primary"
                  title="Enviar e-mail com link de agendamento"
                  @click="selectEmailToSendLink('cerc')"
                >
                  <b-spinner
                    v-if="isSending"
                    small
                  />
                  <feather-icon
                    v-else
                    icon="SendIcon"
                  />
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>

          <b-form-group
            v-if="false"
            label="Link para agendar Apresentação Canal VIP"
            label-for="link_to_schedule"
          >
            <b-input-group>
              <b-form-input
                id="link_to_schedule"
                :value="results.link_to_schedule"
                readonly
              />

              <b-input-group-append>
                <b-button
                  variant="outline-primary"
                  title="Copiar link"
                  @click="sendToClipboard(results.link_to_schedule)"
                >
                  <feather-icon icon="CopyIcon" />
                </b-button>
                <b-button
                  variant="outline-primary"
                  title="Enviar e-mail com link de agendamento"
                  @click="selectEmailToSendLink('presentation')"
                >
                  <b-spinner
                    v-if="isSending"
                    small
                  />
                  <feather-icon
                    v-else
                    icon="SendIcon"
                  />
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>

          <b-button
            v-if="!showLinkTour"
            @click="showLinkTour = true"
          >
            Clique aqui para gerar o link de tour
          </b-button>
          <b-form-group
            v-if="showLinkTour"
            class="mt-1"
            label="Link para agendar Tour da Plataforma"
            label-for="link_to_schedule_tour"
          >
            <b-input-group>
              <b-form-input
                id="link_to_schedule_tour"
                :value="results.link_to_schedule_tour"
                readonly
              />

              <b-input-group-append>
                <b-button
                  variant="outline-primary"
                  title="Copiar link"
                  @click="sendToClipboard(results.link_to_schedule_tour)"
                >
                  <feather-icon icon="CopyIcon" />
                </b-button>
                <b-button
                  variant="outline-primary"
                  title="Enviar e-mail com link de agendamento"
                  @click="selectEmailToSendLink('tour')"
                >
                  <b-spinner
                    v-if="isSending"
                    small
                  />
                  <feather-icon
                    v-else
                    icon="SendIcon"
                  />
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>

        <div
          v-if="false"
          class="mb-2"
        >
          <b-button
            @click="$emit('sort-success-manager')"
          >
            Atribuir Consultor Canal VIP
          </b-button>
        </div>

        <div v-if="canCercRequestUser">
          <b-button
            @click="cercRequestUser('tour')"
          >
            Atribuir usuário
          </b-button>
        </div>

        <b-list-group
          horizontal
          class="mb-1"
        >
          <b-list-group-item v-if="cercManager || userData.permission_type === 'root'">
            <h5 class="mt-0 mb-1 d-flex justify-content-between">
              Consultor CERC

              <b-dropdown
                v-if="['root', 'management_processes'].includes(userData.permission_type)"
                no-caret
                variant="link"
                text="..."
                right
                toggle-class="ml-auto p-0"
                :disabled="isSubmiting"
              >
                <template #button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="align-middle text-body"
                  />
                </template>
                <b-dropdown-item @click.stop="showCercAddModal()">
                  Alterar consultor CERC
                </b-dropdown-item>
              </b-dropdown>
            </h5>
            <b-media v-if="!cercManager">
              <template #aside>
                <b-avatar
                  size="40px"
                  src=""
                  variant="light-success"
                >
                  <feather-icon
                    icon="UserIcon"
                    size="22"
                  />
                </b-avatar>
                <b>
                  Sem consultor
                </b>
              </template>
            </b-media>
            <b-media v-if="cercManager">
              <template #aside>
                <b-avatar
                  size="40px"
                  :src="cercManager && cercManager.avatar ? cercManager.avatar.sm : ''"
                  variant="light-success"
                >
                  <feather-icon
                    icon="UserIcon"
                    size="22"
                  />
                </b-avatar>
              </template>
              <b>
                {{ cercManager.name }}
              </b>
              <div v-if="cercRightUntil">
                Direito Até: {{ formatDateDbToView(cercRightUntil) }}
              </div>
              <div v-if="cercPreferenceUntil">
                Preferência Até: {{ formatDateDbToView(cercPreferenceUntil) }}
              </div>
            </b-media>
          </b-list-group-item>
          <b-list-group-item v-if="salesManager && false">
            <h5 class="mt-0 mb-1 d-flex justify-content-between">
              Executivo de vendas

              <b-dropdown
                v-if="['sales', 'root', 'management_processes'].includes(userData.permission_type)"
                no-caret
                variant="link"
                text="..."
                right
                toggle-class="ml-auto p-0"
                :disabled="isSubmiting"
              >
                <template #button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="align-middle text-body"
                  />
                </template>
                <b-dropdown-item @click.stop="showManagerRemovalModal('sales')">
                  Remover consultor
                </b-dropdown-item>
              </b-dropdown>
            </h5>
            <b-media>
              <template #aside>
                <b-avatar
                  size="40px"
                  :src="salesManager && salesManager.avatar ? salesManager.avatar.sm : ''"
                  variant="light-success"
                >
                  <feather-icon
                    icon="UserIcon"
                    size="22"
                  />
                </b-avatar>
              </template>
              <b>
                {{ salesManager.name }}
              </b>
              <div v-if="results.account_manager_at">
                De: {{ formatDateTimeDbToView(results.account_manager_at) }}
              </div>
              <div v-if="results.account_manager_until">
                Propriedade Até: {{ formatDateTimeDbToView(results.account_manager_property_until) }}
              </div>
              <div v-if="results.account_manager_until">
                Prioridade Até: {{ formatDateTimeDbToView(results.account_manager_priority_until) }}
              </div>
              <div v-if="['sales', 'root', 'management_processes'].includes(userData.permission_type)">
                <b-button
                  v-b-modal.modal-log
                  size="sm"
                >
                  Ver log de EV
                </b-button>
              </div>
            </b-media>
          </b-list-group-item>
          <b-list-group-item v-if="successManager && false && ['root', 'management_processes'].includes(userData.permission_type)">
            <h5 class="mt-0 mb-1 d-flex d-flex justify-content-between">
              Gerente de conta

              <b-dropdown
                v-if="['sales', 'root', 'management_processes'].includes(userData.permission_type)"
                no-caret
                variant="link"
                text="..."
                right
                toggle-class="ml-auto p-0"
                :disabled="isSubmiting"
              >
                <template #button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="align-middle text-body"
                  />
                </template>
                <b-dropdown-item
                  @click.stop="showManagerRemovalModal('success')"
                >
                  Remover consultor
                </b-dropdown-item>
              </b-dropdown>
            </h5>
            <b-media>
              <template #aside>
                <b-avatar
                  size="40px"
                  :src="successManager && successManager.avatar ? successManager.avatar.sm : ''"
                  variant="light-success"
                >
                  <feather-icon
                    icon="UserIcon"
                    size="22"
                  />
                </b-avatar>
              </template>
              <b>
                {{ successManager.name }}
              </b>
              <div v-if="results.success_manager_at">
                De: {{ formatDateTimeDbToView(results.success_manager_at) }}
              </div>
              <div v-if="results.success_manager_until">
                Até: {{ formatDateTimeDbToView(results.success_manager_until) }}
              </div>
            </b-media>
          </b-list-group-item>
        </b-list-group>

        <hr />

        <b-row>
          <b-col cols="12">
            <h3 class="mt-2">
              Hafidme PRO
            </h3>
          </b-col>

          <b-col cols="5">
            <div v-if="results.onivoro_warning_at !== null && results.onivoro_aware_at === null">
              <p>
                <strong>Situação:</strong> Bloqueado<br />
                <strong>Bloqueado em:</strong> {{ results.onivoro_warning_at | date }}<br />
                <strong>Bloqueio número:</strong> {{ results.onivoro_tries }}<br />
                <strong>Bloqueio tipo:</strong> {{ $t(`onivoro.type.${results.onivoro_type}`) }}<br />
                <strong>Liberação requisitada em (somente para bloqueio número 2 ou 3):</strong> {{ results.onivoro_requested_review_at | date }}
              </p>
            </div>
            <div v-else-if="results.onivoro_tries !== null && results.onivoro_tries > 0">
              <p>
                <strong>Situação:</strong> Liberado<br />
                <strong>Quantidade de bloqueios:</strong> {{ results.onivoro_tries }}<br />
              </p>
            </div>
            <div v-else>
              <strong>Situação:</strong> Liberado<br />
            </div>
          </b-col>

          <b-col cols="6">
            <h5 class="">
              Liberar usuário para os tipos:
            </h5>
            <div>
              <b-form-checkbox
                v-model="results.onivoro_release_message"
                class="mr-1"
                variant="secondary"
                switch
              >
                <span
                  title="Mostrar Calendário"
                >Mensagens</span>
              </b-form-checkbox>

              <b-form-checkbox
                v-model="results.onivoro_release_folder_others"
                class="mr-1"
                variant="secondary"
                switch
              >
                <span
                  title="Mostrar Calendário"
                >Pasta outros</span>
              </b-form-checkbox>

              <b-form-checkbox
                v-model="results.onivoro_release_phone"
                class="mr-1"
                variant="secondary"
                switch
              >
                <span
                  title="Mostrar Calendário"
                >Gold</span>
              </b-form-checkbox>
            </div>
          </b-col>

          <b-col cols="6">
            <div
              v-if="results.onivoro_tries > 0"
              class="mt-2"
            >
              <b-card
                border-variant="secondary"
                class="shadow-none mt-2"
              >
                <b-card-title>
                  Ações Hafidme PRO - Nível {{ results.onivoro_tries }}
                </b-card-title>
                <b-card-text>
                  <div
                    v-if="results.onivoro_tries === 4"
                    class="mb-3"
                  >
                    <b-form-group
                      label="Régua"
                      label-for="onivoro_rule"
                    >
                      <b-form-select
                        id="onivoro_rule"
                        v-model="onivoroSelectedRule"
                        class="form-select"
                        :disabled="!results.onivoro_requested_review_at"
                        :options="onivoroRules"
                      />
                    </b-form-group>

                    <b-button
                      size="sm"
                      :disabled="!results.onivoro_requested_review_at || onivoroSelectedRule === ''"
                      @click="onivoroReleaseLvl2()"
                    >
                      Enviar e-mail
                    </b-button>

                    <span
                      v-if="!results.onivoro_requested_review_at"
                      class="d-block"
                    >O e-mail só pode ser enviado após o usuário enviar a solicitação por escrito no site</span>
                  </div>

                  <div
                    v-if="results.onivoro_warning_at"
                    class="mb-1"
                  >
                    <span>Remover alerta do Hafidme PRO, liberando o usuário para usar o site</span>
                    <br />
                    <b-button
                      size="sm"
                      @click="onivoroRelease()"
                    >
                      Liberar cadastro
                    </b-button>
                  </div>

                  <div
                    v-if="userData.permission_type === 'root'"
                    class="mt-3"
                  >
                    <span>Reseta todos os bloqueios, como se o usuário nunca tivesse caído no Hafidme PRO</span>
                    <b-button
                      class="mt"
                      size="sm"
                      @click="onivoroReset()"
                    >
                      Resetar bloqueios
                    </b-button>
                  </div>
                </b-card-text>
              </b-card>
            </div>
          </b-col>
        </b-row>

        <hr />

        <b-modal
          id="modal-manager-add"
          ref="modal-manager-add"
          content-class="shadow"
          title="Forçar consultor de CERC"
          no-fade
          cancel-title="Cancelar"
          ok-title="Salvar"
          :ok-disabled="isCercSubmiting"
          :cancel-disabled="isCercSubmiting"
          @ok="addCercManagerPost"
        >
          <b-card-text>
            <validation-observer ref="rulesAddCerc">
              Selecione o consultor e as datas para forçar o CERC neste usuário

              <b-col>
                <b-form-group
                  label="Consultor com Direito"
                  label-for="consultor"
                >
                  <validation-provider
                    #default="{ errors }"
                  >
                    <b-form-select
                      id="consultor"
                      v-model="addCercManager.right_manager_id"
                      class="form-select"
                      :options="listManagersForModalCerc"
                      @change="selectRightManager"
                    />

                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group
                  label="Direito em"
                  label-for="date_picker_right_at"
                >
                  <validation-provider
                    #default="{ errors }"
                    :rules="`${addCercManager.right_manager_id && addCercManager.right_manager_id > 0 ? 'required' : ''}`"
                  >
                    <flat-pickr
                      id="date_picker_right_at"
                      ref="datePicker"
                      v-model="addCercManager.right_at"
                      class="form-control"
                      :config="pickrConfig"
                    />

                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col>
                <hr />
              </b-col>

              <b-col>
                <b-form-group
                  label="Consultor com Preferência"
                  label-for="consultor"
                >
                  <validation-provider
                    #default="{ errors }"
                    rules="required"
                  >
                    <b-form-select
                      id="consultor"
                      v-model="addCercManager.preference_manager_id"
                      class="form-select"
                      :options="listPreferenceManagersForModalCerc"
                    />

                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group
                  label="Preferência vinculada ao plano (data final - consultor já vinculado)"
                  label-for="plan_quota_id"
                >
                  <validation-provider
                    #default="{ errors }"
                    rules="required"
                  >
                    <b-form-select
                      id="payment_id"
                      v-model="addCercManager.plan_quota_id"
                      class="form-select"
                      :options="userLatestPlans"
                    />
                    <small>Ao selecionar um novo consultor a comissão também será alterada para ele</small>

                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </validation-observer>
          </b-card-text>
        </b-modal>

        <b-modal
          id="modal-manager-removal"
          ref="modal-manager-removal"
          content-class="shadow"
          title="Remover consultor"
          no-fade
          ok-title="Remover"
          @ok="removeManager(managerRemovalType)"
        >
          <b-card-text>
            Você tem certeza que deseja remover o
            <span v-if="managerRemovalType === 'sales'">
              executivo de vendas
            </span>
            <span v-else-if="managerRemovalType === 'success'">
              gerente de contas
            </span>
            deste usuário?
          </b-card-text>
        </b-modal>

        <b-row>
          <b-col cols="12">
            <b-form-group
              label=""
              label-for="registration_info_type"
            >
              <validation-provider #default="{ errors }">
                <b-form-checkbox
                  v-model="results.receive_alert_of_new_opportunities"
                  :disabled="isSubmiting"
                  checked="true"
                  name="check-button"
                  switch
                  inline
                >
                  Receber alerta de novas oportunidades
                </b-form-checkbox>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group
              label=""
              label-for="registration_delay_emails"
            >
              <validation-provider #default="{ errors }">
                <b-form-select
                  id="registration_delay_emails"
                  v-model="results.delay_emails"
                  :options="delayEmails"
                  :state="errors.length > 0 ? false : null"
                />
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-form-group
              label=""
              label-for="registration_info_type"
            >
              <validation-provider #default="{ errors }">
                <b-form-checkbox
                  v-model="results.receive_alert_on_whatsapp"
                  :disabled="isSubmiting"
                  checked="true"
                  name="check-button"
                  switch
                  inline
                >
                  Receber alerta de nova conversa no Whats App
                </b-form-checkbox>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-form-group
              label=""
              label-for="registration_info_type"
            >
              <validation-provider #default="{ errors }">
                <b-form-checkbox
                  v-model="results.receive_alert_of_new_messages"
                  :disabled="isSubmiting"
                  checked="true"
                  name="check-button"
                  switch
                  inline
                >
                  Receber alerta de nova conversa/mensagem no e-mail
                </b-form-checkbox>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-form-group
              label=""
              label-for="registration_info_type"
            >
              <validation-provider #default="{ errors }">
                <b-form-checkbox
                  v-model="results.receive_automatic_search"
                  :disabled="isSubmiting"
                  checked="true"
                  name="check-button"
                  switch
                  inline
                >
                  Receber busca automática
                </b-form-checkbox>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-form-group
              label=""
              label-for="registration_info_type"
            >
              <validation-provider #default="{ errors }">
                <b-form-checkbox
                  v-model="results.show_phones"
                  :disabled="isSubmiting"
                  checked="true"
                  name="check-button"
                  switch
                  inline
                >
                  Mostrar telefones
                </b-form-checkbox>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col
            v-if="userData.permission_type === 'root'"
            cols="12"
          >
            <b-form-group
              label=""
              label-for="registration_info_type"
            >
              <validation-provider #default="{ errors }">
                <b-form-checkbox
                  v-model="results.indication_reset"
                  :disabled="isSubmiting"
                  checked="true"
                  name="check-button"
                  switch
                  inline
                >
                  Recolocar na fila de indicação
                  <small>(Último envio
                    {{
                      results.indication_sent | date('DD/MM/Y H:m:s')
                    }})</small>
                </b-form-checkbox>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-form-group
              label="Mensagem Padrão"
              label-for="registration_info_type"
            >
              <validation-provider #default="{ errors }">
                <b-form-textarea
                  v-model="results.default_message_to_connection"
                  :disabled="isSubmiting"
                  name="check-button"
                  rows="10"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <h4 class="mt-1">
              Bot de Resposta
            </h4>
          </b-col>

          <b-col cols="12">
            <div class="text-right">
              <b-button
                variant="secondary"
                @click="randomDefaultResponseToConnection"
              >
                Modelo aleatório
              </b-button>
            </div>
            <b-form-group
              label="Mensagem automática"
              label-for="registration_info_type"
            >
              <validation-provider #default="{ errors }">
                <b-form-textarea
                  v-model="results.default_response_to_connection"
                  :disabled="isSubmiting"
                  name="check-button"
                  rows="10"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-form-group>
              <validation-provider #default="{ errors }">
                <b-form-checkbox
                  v-model="results.default_response_only_main_folder"
                  :disabled="isSubmiting"
                  switch
                  inline
                >
                  Responder automaticamente somente as mensagens da Pasta
                  Principal
                </b-form-checkbox>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-form-group>
              <validation-provider #default="{ errors }">
                <b-form-checkbox
                  v-model="results.default_response_hide_email"
                  :disabled="isSubmiting"
                  switch
                  inline
                >
                  Ocultar <strong>E-mail</strong> na Resposta Automática
                </b-form-checkbox>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-form-group>
              <validation-provider #default="{ errors }">
                <b-form-checkbox
                  v-model="results.default_response_hide_cellphone"
                  :disabled="isSubmiting"
                  switch
                  inline
                >
                  Ocultar <strong>Celular/WhatsApp</strong> na Resposta
                  Automática
                </b-form-checkbox>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-form-group>
              <validation-provider #default="{ errors }">
                <b-form-checkbox
                  v-model="results.default_response_hide_phone"
                  :disabled="isSubmiting"
                  name="check-button"
                  switch
                  inline
                >
                  Ocultar <strong>Telefone</strong> na Resposta Automática
                </b-form-checkbox>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-form-group>
              <validation-provider #default="{ errors }">
                <b-form-checkbox
                  v-model="results.default_response_delayed"
                  :disabled="isSubmiting"
                  name="check-button"
                  switch
                  inline
                >
                  Ativar espera de 48 horas (neste caso, a Resposta Automática
                  não será enviada imediatamente. Será enviada apenas após 48
                  horas caso você não responda a mensagem)
                </b-form-checkbox>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col
            cols="12"
            class="text-right"
          >
            <b-button
              align="right"
              variant="primary"
              type="submit"
              :disabled="isSubmiting || isLoading"
              @click.prevent="updateSettings()"
            >
              Salvar
              <b-spinner
                v-if="isSubmiting"
                small
              />
            </b-button>
          </b-col>
        </b-row>
      </validation-observer>
    </b-form>

    <b-modal
      v-if="!isLoading"
      id="modal-log"
      ref="modal-log"
      title="Log de vendas"
      footer-class="justify-content-center"
      ok-only
      ok-title="Fechar"
      ok-variant="danger"
    >
      <div
        v-for="log in results.sales_log"
        :key="log.manager_id"
      >
        <span
          class="font-weight-bold d-inline-block"
          style="width: 140px"
        >Consultor: </span>
        <span>{{ log.manager_name }}</span>
        <br />

        <span
          class="font-weight-bold d-inline-block"
          style="width: 140px"
        >Último contato: </span>
        <span>{{ log.last_contacted | date }}</span>
        <br />

        <span
          class="font-weight-bold d-inline-block"
          style="width: 140px"
        >E-mail enviado: </span>
        <span>{{ log.last_email | date }}</span>
        <br />

        <span
          class="font-weight-bold d-inline-block"
          style="width: 140px"
        >Anotação: </span>
        <span>{{ log.last_annotation | date }}</span>
        <br />
        <br />
      </div>
    </b-modal>

    <b-modal
      v-if="!isLoading"
      id="modal-log-cerc"
      ref="modal-log-cerc"
      title="Log de Cerc"
      footer-class="justify-content-center"
      ok-only
      ok-title="Fechar"
      ok-variant="danger"
    >
      <div v-if="results.cerc_log.length === 0">
        Nenhum log encontrado
      </div>

      <div
        v-for="log in results.cerc_log"
        :key="log.manager_id"
      >
        <span
          class="font-weight-bold d-inline-block modal-log-cerc-title"
        >Consultor: </span>
        <span>{{ log.manager_name }}</span>
        <br />

        <span
          class="font-weight-bold d-inline-block modal-log-cerc-title"
        >Último contato: </span>
        <span>{{ log.last_contacted | date }}</span>
        <br />

        <span
          class="font-weight-bold d-inline-block modal-log-cerc-title"
        >E-mail enviado: </span>
        <span>{{ log.last_email | date }}</span>
        <br />

        <span
          class="font-weight-bold d-inline-block modal-log-cerc-title"
        >Anotação: </span>
        <span>{{ log.last_annotation | date }}</span><br />

        <span
          class="font-weight-bold d-inline-block modal-log-cerc-title"
        >Confirmação de E-mail: </span>
        <span>{{ log.last_email_confirmation | date }}</span><br />

        <span
          class="font-weight-bold d-inline-block modal-log-cerc-title"
        >Confirmação de Telefone/Whatsapp: </span>
        <span>{{ log.last_phone_confirmation | date }}</span>
        <br />
        <br />
      </div>
    </b-modal>

  </b-card>
</template>

<script>
import Vue from 'vue'
import UserService from '@/services/userService'
import FinancialService from '@/services/financialService'
import SchedulerService from '@/services/schedulerService'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  BCardHeader,
  BCardTitle,
  BAvatar,
  BButton,
  BCard,
  BCardText,
  BCol,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BDropdown,
  BDropdownItem,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormSelect,
  VBModal,
  BFormTextarea,
  BListGroup,
  BListGroupItem,
  BMedia,
  BModal,
  BRow,
  BSpinner,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { formatDateDbToView, formatDateTimeDbToView } from '@/utils/helpers'
import { delayEmails, onivoroRules } from '@/utils/options'
import sendToClipboard from '@/mixins/sendToClipboard'
import requestErrorMessage from '@/mixins/requestErrorMessage'
import flatPickr from 'vue-flatpickr-component'
import { Portuguese } from 'flatpickr/dist/l10n/pt'
import swall from '@/mixins/swall'
import toast from '@/mixins/toast'

export default {
  components: {
    BCardHeader,
    BCardTitle,
    BAvatar,
    BButton,
    BCard,
    BCardText,
    BCol,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BDropdown,
    BDropdownItem,
    BForm,
    BFormCheckbox,
    BFormGroup,
    BFormSelect,
    BFormTextarea,
    BListGroup,
    BListGroupItem,
    BMedia,
    BModal,
    BRow,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    flatPickr,
  },

  directives: {
    'b-modal': VBModal,
  },

  mixins: [sendToClipboard, requestErrorMessage, swall, toast],

  props: {
    userId: {
      type: Number,
      default: null,
    },
    userEditing: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      formatDateTimeDbToView,
      formatDateDbToView,
      delayEmails,
      isSubmiting: false,
      isCercSubmiting: false,
      isSending: false,
      userData: null,
      showLinkTour: false,
      isLoading: true,
      userService: null,
      financialService: null,
      userLatestPlans: [],
      initExecuted: false,
      settings: '',
      results: {},
      managers: [],
      managerRemovalType: '',
      selectedEmail: '',
      onivoroSelectedRule: '',
      onivoroRules,
      releaseOnivoro: {
        message: false,
        folder_other: false,
        phone: false,
      },
      addCercManager: {
        right_manager_id: null,
        right_at: null,
        preference_manager_id: null,
        plan_quota_id: null,
      },
      pickrConfig: {
        mode: 'single',
        // noCalendar: true,
        // inline: true,
        allowInput: false,
        position: 'auto center',
        enableTime: true,
        dateFormat: 'Y-m-d H:i:s',
        altFormat: 'd/m/Y H:i',
        altInput: true,
        // minDate: new Date().setMinutes(Math.floor((new Date()).getMinutes() / 5) * 5),
        time_24hr: true,
        locale: Portuguese,
      },
    }
  },

  computed: {
    listPreferenceManagersForModalCerc() {
      if (this.addCercManager.right_manager_id) {
        return this.listManagersForModalCerc.filter(f => f.value === this.addCercManager.right_manager_id || f.value === 0)
      }

      return this.listManagersForModalCerc
    },

    listManagersForModalCerc() {
      return [
        {
          text: 'Nenhum',
          value: 0,
        },
        ...this.managers.map(m => ({
          text: m.name,
          value: m.id,
        })),
      ]
    },

    emailsFromUser() {
      return [
        ...[this.userEditing.email ?? ''],
        ...this.userEditing.emails ?? [],
      ]
    },

    cercRightUntil() {
      if (this.results.cerc_right_until) {
        return this.results.cerc_right_until.substring(0, 10)
      }

      return null
    },

    cercPreferenceUntil() {
      if (this.results.cerc_preference_until) {
        return this.results.cerc_preference_until.substring(0, 10)
      }

      return null
    },

    canCercRequestUser() {
      return (
        this.results.cerc_preference_manager_id === this.userData.id
          || this.results.cerc_right_manager_id === this.userData.id
          || (this.results.user && this.results.user.kanban && this.results.user.kanban.account_manager_id === this.userData.id)
      )
        && this.results.user
        && this.results.user.kanban
        && this.results.user.kanban.column === 'finished'
        // && this.results.user.situation !== 'paying'
    },

    cercManager() {
      if (this.results.cerc_preference_manager_id) {
        return this.managers.find(f => f.id === this.results.cerc_preference_manager_id)
      }

      if (this.results.cerc_right_manager_id) {
        return this.managers.find(f => f.id === this.results.cerc_right_manager_id)
      }

      return null
    },
    salesManager() {
      if (!this.results.account_manager_id) return null

      return this.managers.find(f => f.id === this.results.account_manager_id)
    },
    successManager() {
      if (!this.results.success_manager_id) return null

      return this.managers.find(f => f.id === this.results.success_manager_id)
    },
  },

  async created() {
    this.userService = new UserService()
    this.financialService = new FinancialService()
    const userDataString = await localStorage.getItem('userData')
    this.userData = await JSON.parse(userDataString)
  },

  methods: {
    selectRightManager() {
      if (this.addCercManager.preference_manager_id && this.addCercManager.preference_manager_id !== this.addCercManager.right_manager_id) {
        this.addCercManager.preference_manager_id = null
      }
    },

    async addCercManagerPost(bvModalEvt) {
      bvModalEvt.preventDefault()

      const success = await this.$refs.rulesAddCerc.validate()
      if (!success) {
        return
      }

      this.isCercSubmiting = true
      this.userService.updateCercManager(this.userId, this.addCercManager).then(() => {
        this.toastSuccess('CERC alterado com sucesso!')
      }).catch(error => {
        this.swallError('Erro ao alterar CERC', this.getResponseErrorMessage(error.response), 'Ok')
      }).finally(() => {
        this.isCercSubmiting = false
      })

      bvModalEvt.preventDefault()
    },
    onivoroReset() {
      this.$swal({
        title: 'Hafidme PRO',
        text: 'Resetar todos os bloqueios onivoro deste usuário?',
        icon: 'question',
        confirmButtonText: 'Sim, resetar',
        cancelButtonText: 'Cancelar',
        showCancelButton: true,
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-secondary',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          this.isLoading = true
          await UserService.onivoroReset(this.userId)
          await this.getSettings(this.userId)
          this.toastSuccess('Hafidme PRO resetado!')
        }
      })
    },
    onivoroRelease() {
      this.$swal({
        title: 'Hafidme PRO',
        text: 'Confirmar liberação de acesso ao usuário?',
        icon: 'question',
        confirmButtonText: 'Sim, confirmar',
        cancelButtonText: 'Cancelar',
        showCancelButton: true,
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-secondary',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          this.isLoading = true
          await UserService.onivoroRelease(this.userId, '')
          await this.getSettings(this.userId)
          this.toastSuccess('Usuário liberado!')
        }
      })
    },
    onivoroReleaseLvl2() {
      this.$swal({
        title: 'Hafidme PRO',
        text: 'Enviar e-mail com instruções do Hafidme PRO para o usuário?',
        icon: 'question',
        confirmButtonText: 'Sim, confirmar',
        cancelButtonText: 'Cancelar',
        showCancelButton: true,
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-secondary',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          this.isLoading = true
          await UserService.onivoroRelease(this.userId, this.onivoroSelectedRule)
          await this.getSettings(this.userId)
          this.toastSuccess('E-mail enviado!')
        }
      })
    },
    cercRequestUser() {
      this.$swal({
        title: 'Atribuição',
        text: 'Solicitar atribuição do usuário??',
        icon: 'question',
        confirmButtonText: 'Sim, solicitar',
        cancelButtonText: 'Cancelar',
        showCancelButton: true,
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-secondary',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.isSending = true
          UserService
            .cercRequestUser(this.userId)
            .then(() => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Solicitação de atribuição enviada',
                  text: '',
                  icon: 'EditIcon',
                  variant: 'success',
                },
              })
            })
            .catch(error => {
              this.$swal({
                title: 'Ops - Algum erro aconteceu',
                text: this.getResponseErrorMessage(error.response.data),
                icon: 'error',
                customClass: {
                  confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
              })
            }).finally(() => {
              this.isSending = false
            })
        }
      })
    },
    selectEmailToSendLink(type) {
      this.$swal({
        title: 'Convite',
        text: 'Enviar convite de agendamento para o usuário?',
        icon: 'question',
        confirmButtonText: 'Sim, enviar convite',
        cancelButtonText: 'Cancelar',
        showCancelButton: true,
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-secondary',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.isSending = true
          SchedulerService
            .postSendLinkToSchedule(this.userData.id, this.userId, type)
            .then(() => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'E-mail enviado',
                  text: '',
                  icon: 'EditIcon',
                  variant: 'success',
                },
              })
            })
            .catch(error => {
              this.$swal({
                title: 'Ops - Existem erros de validação',
                text: this.getResponseErrorMessage(error.response.data),
                icon: 'error',
                customClass: {
                  confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
              })
            }).finally(() => {
              this.isSending = false
            })
        }
      })
    },

    userHash(userEditing) {
      return SchedulerService.getHash(userEditing.created_at)
    },

    async init() {
      if (!this.initExecuted) {
        await this.userService.getAndStoreManagers().then(managers => {
          this.managers = managers
        })
        await this.getSettings(this.userId)
        await this.getLatestQuotas(this.userId)
        this.initExecuted = true
      }
    },

    async reset() {
      this.isLoading = true
      if (!this.initExecuted) {
        await this.init()
      } else {
        await this.getSettings(this.userId)
        await this.getLatestQuotas(this.userId)
      }
    },

    openTransaction(row) {
      this.$emit('open-transaction', row.item.payment_transaction_id)
    },

    getLatestQuotas(userId) {
      return this.userService.listQuotas(userId).then(response => {
        this.userLatestPlans = [
          {
            text: 'Nenhum',
            value: 0,
          },
          ...response.data.data.quotas.slice(0, 10).map(m => ({
            text: `${formatDateDbToView(m.end_of_plan)} - ${m.manager && m.manager.name ? m.manager.name : 'Sem consultor'}`,
            value: m.id,
          }))]
        this.addCercManager.plan_quota_id = (this.userLatestPlans.length > 1) ? this.userLatestPlans[1].value : 0
      })
    },

    async getSettings(userId) {
      return this.userService.listSettings(userId).then(response => {
        const {
          default_message_to_connection,
          receive_alert_of_new_opportunities,
          receive_alert_on_whatsapp,
          receive_automatic_search,
          receive_alert_of_new_messages,
          show_phones,
          indication_sent,
          cerc_right_manager_id,
          cerc_right_at,
          cerc_right_until,
          cerc_preference_manager_id,
          cerc_preference_at,
          cerc_preference_until,
          account_manager_id,
          account_manager_at,
          account_manager_until,
          account_manager_priority_until,
          account_manager_property_until,
          success_manager_id,
          success_manager_at,
          success_manager_until,
          delay_emails,
          default_response_to_connection,
          default_response_only_main_folder,
          default_response_hide_email,
          default_response_hide_cellphone,
          default_response_hide_phone,
          default_response_delayed,
          link_to_schedule,
          link_to_schedule_tour,
          link_to_schedule_cerc,
          sales_log,
          cerc_log,
          onivoro_aware_at,
          onivoro_tries,
          onivoro_type,
          onivoro_warning_at,
          onivoro_requested_review_at,
          onivoro_release_message,
          onivoro_release_folder_others,
          onivoro_release_phone,
          user,
        } = response.data.data.settings

        this.addCercManager.right_manager_id = response.data.data.settings.cerc_right_manager_id
        this.addCercManager.right_at = response.data.data.settings.cerc_right_at
        this.addCercManager.preference_manager_id = response.data.data.settings.cerc_preference_manager_id

        this.results = {
          default_message_to_connection,
          receive_alert_of_new_opportunities,
          receive_alert_on_whatsapp,
          receive_automatic_search,
          receive_alert_of_new_messages,
          show_phones,
          indication_sent,
          indication_reset: false,
          cerc_right_manager_id,
          cerc_right_at,
          cerc_right_until,
          cerc_preference_manager_id,
          cerc_preference_at,
          cerc_preference_until,
          account_manager_id,
          account_manager_at,
          account_manager_until,
          account_manager_priority_until,
          account_manager_property_until,
          success_manager_id,
          success_manager_at,
          success_manager_until,
          delay_emails,
          default_response_to_connection,
          default_response_only_main_folder,
          default_response_hide_email,
          default_response_hide_cellphone,
          default_response_hide_phone,
          default_response_delayed,
          link_to_schedule,
          link_to_schedule_tour,
          link_to_schedule_cerc,
          sales_log,
          cerc_log,
          onivoro_aware_at,
          onivoro_tries,
          onivoro_type,
          onivoro_warning_at,
          onivoro_requested_review_at,
          onivoro_release_message,
          onivoro_release_folder_others,
          onivoro_release_phone,
          user,
        }
        this.isLoading = false
      })
    },

    updateSettings() {
      this.isSubmiting = true

      const {
        default_message_to_connection,
        receive_alert_of_new_opportunities,
        receive_alert_on_whatsapp,
        receive_automatic_search,
        receive_alert_of_new_messages,
        show_phones,
        indication_reset,
        delay_emails,
        default_response_to_connection,
        default_response_only_main_folder,
        default_response_hide_email,
        default_response_hide_cellphone,
        default_response_hide_phone,
        default_response_delayed,
        onivoro_release_message,
        onivoro_release_folder_others,
        onivoro_release_phone,
      } = this.results

      const data = {
        default_message_to_connection,
        receive_alert_of_new_opportunities,
        receive_alert_on_whatsapp,
        receive_alert_of_new_messages,
        receive_automatic_search,
        show_phones,
        indication_reset,
        delay_emails,
        default_response_to_connection,
        default_response_only_main_folder,
        default_response_hide_email,
        default_response_hide_cellphone,
        default_response_hide_phone,
        default_response_delayed,
        onivoro_release_message,
        onivoro_release_folder_others,
        onivoro_release_phone,
      }

      this.userService
        .updateSettings(this.userId, data)
        .then(() => {
          this.isSubmiting = false

          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Alteração salva',
              text: '',
              icon: 'EditIcon',
              variant: 'success',
            },
          })
        })
        .catch(error => {
          this.$swal({
            title: 'Ops - Existem erros de validação',
            text: Object.values(error.response.data.errors),
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
          })

          this.isSubmiting = false
        })
    },

    sortingChanged(ctx) {
      if (ctx.sortBy !== '') {
        this.filtersValues.sortBy = ctx.sortBy
        this.filtersValues.sortDesc = ctx.sortDesc
      }
    },

    showManagerRemovalModal(type) {
      this.managerRemovalType = type
      this.$refs['modal-manager-removal'].show()
    },

    showCercAddModal() {
      this.$refs['modal-manager-add'].show()
    },

    removeManager(type) {
      this.isSubmiting = true

      UserService.removeManager(this.userId, type)
        .then(() => {
          this.isSubmiting = false

          if (type === 'success') {
            this.results = {
              ...this.results,
              success_manager_id: null,
              success_manager_at: null,
            }
          } else if (type === 'sales') {
            this.results = {
              ...this.results,
              account_manager_id: null,
              account_manager_at: null,
            }
          }

          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Consultor Removido',
              text: '',
              icon: 'EditIcon',
              variant: 'success',
            },
          })
        })
        .catch(error => {
          this.$swal({
            title: 'Não foi possível remover o consultor',
            text: Object.values(error.response.data.errors),
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
          })
        })
        .finally(() => {
          this.isSubmiting = false
        })
    },
    randomDefaultResponseToConnection() {
      const cellphone = Vue.filter('phone')(this.userEditing?.cell_phone)
      const { email } = this.userEditing
      const defaultResponses = [
        `Obrigado pelo seu interesse! Fico à disposição para conversarmos melhor sobre o assunto.

Por favor, entre em contato comigo por telefone/WhatsApp no número ${cellphone} ou por email no endereço ${email}.

Aguardo seu contato.`,
        `Agradeço pelo seu interesse! Seria ótimo podermos conversar mais sobre o assunto.

Por favor, entre em contato comigo por telefone/WhatsApp, no número ${cellphone}, ou por email, no endereço ${email}. Espero ouvir de você em breve.`,
        `Obrigado por demonstrar interesse! Para conversarmos melhor sobre o assunto, peço que entre em contato comigo.

Você pode me ligar ou enviar uma mensagem via telefone/WhatsApp no número ${cellphone}, ou me enviar um email para ${email}.

Estou aguardando seu contato.`,
        `Agradeço pelo interesse demonstrado! Estou disponível para conversarmos mais sobre o assunto.

Por favor, entre em contato comigo por telefone/WhatsApp, no número ${cellphone}, ou por email, no endereço ${email}.

Espero receber sua mensagem em breve.`,
        `Obrigado pelo interesse! Ficarei feliz em conversar mais sobre o assunto.

Por favor, entre em contato comigo por telefone/WhatsApp, no número ${cellphone}, ou por email, no endereço ${email}.

Aguardo seu contato para discutirmos melhor.`,
        `Agradeço pelo interesse manifestado! Para podermos discutir melhor o assunto, peço que entre em contato comigo. Você pode me ligar ou enviar uma mensagem via telefone/WhatsApp no número ${cellphone}, ou me enviar um email para ${email}.

Aguardo seu retorno.`,
        `Obrigado pelo interesse! Será um prazer conversar mais sobre o assunto. Por favor, entre em contato comigo por telefone/WhatsApp, no número ${cellphone}, ou por email, no endereço ${email}.

Aguardo para trocar informações com você.`,
        `Agradeço pelo interesse! Estou à disposição para conversarmos melhor sobre o assunto. Por favor, entre em contato comigo por telefone/WhatsApp, no número ${cellphone}, ou por email, no endereço ${email}.

Aguardo seu contato para darmos continuidade à conversa.`,
        `Obrigado pelo seu interesse! Fico à disposição para conversarmos mais sobre o assunto. Por favor, entre em contato comigo por telefone/WhatsApp, no número ${cellphone}, ou por email, no endereço ${email}.

Aguardo seu retorno para prosseguirmos.`,
        `Agradeço pelo interesse manifestado! Será um prazer conversar mais sobre o assunto.

Por favor, entre em contato comigo por telefone/WhatsApp, no número ${cellphone}, ou por email, no endereço ${email}.

Estou aguardando seu contato para trocarmos informações.`,
        `Obrigado pelo interesse! Por favor, entre em contato comigo por telefone/WhatsApp, ou por email, para conversarmos melhor sobre o assunto.
${cellphone}
${email}

Att,`,
      ]

      const seed = Math.round(Date.now() / 1000)
      const prng = seed % defaultResponses.length

      this.results.default_response_to_connection = defaultResponses[prng]
    },
  },
}
</script>

<style scoped>
.modal-log-cerc-title {
  width: 200px;
}
.card .card-header.low-padding {
  padding: 0.75rem;
  padding-bottom: 1.5rem;
}
h4 {
  margin-bottom: 20px;
}
</style>
